<ng-select
  [ngClass]="{ searchable: searchable }"
  [virtualScroll]="virtualScroll"
  [typeahead]="searchSubject$"
  [searchable]="searchable"
  [(ngModel)]="_value"
  [multiple]="multiple"
  [closeOnSelect]="!multiple"
  [clearable]="false"
  [compareWith]="compareFn"
  (change)="change($event)"
  [markFirst]="false"
  [placeholder]="filterName | translate"
  (scroll)="onScroll($event.end)"
  (scrollToEnd)="fetchMoreItems(filterSelect.searchTerm || '')"
  #filterSelect
>
  <ng-option
    *ngFor="let item of itemsBuffer; trackBy: trackByFn"
    [value]="item"
  >
    <div [ngClass]="{ 'd-flex flex-column overflow-hidden': displaySubLabel && optionSubLabelSegments.length }">
      <i
        *ngIf="customAvatarIcon"
        class="fa-solid me-3"
        [ngClass]="customAvatarIcon"
      ></i>
      <span
        *ngIf="!combineLabel"
        [ngClass]="optionClass ? item[optionClass] : ''"
        >{{ item[bindOptionLabel] | translate }}</span
      >
      <span
        *ngIf="combineLabel"
        [ngClass]="optionClass ? item[optionClass] : ''"
        >{{ item[combineLabel[0]] + ' ' + item[combineLabel[1]] }}</span
      >
      <ng-container *ngIf="displaySubLabel && optionSubLabelSegments.length">
        <span
          class="fw-normal text-dark-gray item-sub-label mb-0"
          *ngIf="item[optionSubLabelSegments[0]] && item[optionSubLabelSegments[0]][optionSubLabelSegments[1]]"
        >
          {{ item[optionSubLabelSegments[0]][optionSubLabelSegments[1]] }}
        </span>
      </ng-container>
    </div>
    <ng-container *ngIf="isRatingLayout">
      <base-rating
        [currentRate]="item"
        [hideCount]="true"
      ></base-rating>
    </ng-container>
  </ng-option>
</ng-select>
